import axios from 'axios'
import { API_PROYT, API_REVIEW, API_ISSUE } from '../../config/config.json'

export async function setDataDashboard(data) {  
  let config = {
    method: 'post',
    url: `${API_PROYT}/getprocessinformation`,
    headers: {
      'Content-Type': 'application/json'
    },data  
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    });
}

export async function getHistoric(data) {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_PROYT}/getstatushistory`,
    headers: {
      'Content-Type': 'application/json', 'accept': '*/*'
    },data: JSON.stringify(data.ceid)    
  };
  
  return axios.request(config)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getStatusList(data) {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_PROYT}/getservicestatus`,
    headers: {
      'Content-Type': 'application/json', 'accept': '*/*'
    },data: data    
  };
  
  return axios.request(config)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getSubjectData(data) {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_PROYT}/getsubjectdata`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  };

  return axios.request(config)
    .then((response) => {
      return response.data.data[0];
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function getInfoProcess(data) {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_PROYT}/getsubscriberdata`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data.ceid)
  };

  return axios.request(config)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
}

export async function setReviewService(data) {
  //console.log(data);
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_REVIEW}`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  };

  return axios.request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data
    })
}

export async function setEmissionService(data) {
  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${API_ISSUE}`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  };

  return axios.request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response.data.data.includes("CertificateCreateException") ||
      error.response.data.data.includes("CryptoTokenOfflineException") || 
      error.response.data.data.includes("Error invocando") ||
      error.response.data.data.includes("The server didn't respond in time.") ||
      error.response.data.data.includes("One or more errors occurred. (A task was canceled.)")
      ){
        return { data:'Fallo en la PKi' }
      } else if (error.response.data.data === "One or more errors occurred. (The SSL connection could not be established, see inner exception.)") {
        return { data:'Falló en la generación del documento' }
      } else {
        const errorData = error.response.data.data ? error.response.data.data : 'Falló ejecutando solicitud';
        return { data: errorData }
      }
    });
}

export async function getCausesRevoke() {
  let config = {
    method: 'get',
    url: `${API_PROYT}/ProjectT/getcauserevocation`,
    headers: {
      'Content-Type': 'application/json'
    }
  };

  return axios.request(config)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      return error.response.data
    })
}

export async function setRevokeFile(data) {
  let config = {
    method: 'post',
    url: `${API_PROYT}/ProjectT/revocationfile`,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data:data
  };
  return axios.request(config)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      return error.response.data
    })
}

export async function getCausesReject() {
  let config = {
    method: 'get',
    url: `${API_PROYT}/ProjectT/getRejectionReason`,
    headers: {
      'Content-Type': 'application/json'
    }
  };

  return axios.request(config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response.data
    })
}

export async function setRejectProcess(data) {
  let config = {
    method: 'post',
    url: `${API_PROYT}/ProjectT/rejectrequest`,
    headers: {
      "Content-Type": "application/json"
    },
    data:data
  };
  return axios.request(config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response.data
    })
}

export async function getIssueFile(data) {
  let config = {
    method: 'get',
    url: `${API_PROYT}/ProjectT/getissuecertificate`,
    headers: {
      'Content-Type': 'application/json',
      "exId": data
    }
  };
  return axios.request(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.data.data
    })
}